import { Role, UserType } from '@nemuru-eng/js-api-client';

export const RoleMap = {
  fromUserType: (userType: UserType): Role => {
    if (userType === UserType.MERCHANT) return Role.ROLE_MERCHANT;
    if (userType === UserType.CHANNEL) return Role.ROLE_CHANNEL;
    if (userType === UserType.AGENT) return Role.ROLE_AGENT;
    return Role.ROLE_AGENT;
  },
};
